// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"140":"76d28868","269":"0d44808c","291":"666a9428","674":"7f72aac0"}[chunkId] + ".js";
};